exports.calc = function calc() {return elementorySupport.getJSON(generateWebMethodUrl("calc","backend/calculate.jsw"), arguments, undefined, undefined)}